import type { CustomCellEditorProps } from "ag-grid-react";
import { type ChangeEvent, useEffect, useRef, useState } from "react";

import { isBackspace, isPrintableKey } from "@/ui-modules/core/grid/cells/editors/utils.ts";

import { TableCell } from "../core/TableCell.js";

export const NumberCellEditor = (props: CustomCellEditorProps) => {
  const isPrintableEditingKey = isPrintableKey(props.eventKey);
  const isBackspaceKey = isBackspace(props.eventKey);
  const [value, setValue] = useState<string>(isPrintableEditingKey ? props.eventKey : props.value);
  const refInput = useRef<HTMLInputElement>(null);

  useEffect(() => {
    refInput.current?.focus();
  }, []);

  const onChangeListener = (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = event.currentTarget.value?.trim();

    setValue(newValue);
    props.onValueChange(newValue ? Number(newValue) : null);
  };

  return (
    <TableCell editor>
      <input
        className={"form-control"}
        ref={refInput}
        value={value}
        type="number"
        onChange={onChangeListener}
        onFocus={(event) => (isBackspaceKey ? setValue("") : isPrintableEditingKey ? undefined : event.target.select())}
        onBlur={() => props.stopEditing()}
      />
    </TableCell>
  );
};
